import React from 'react';
import { images } from '../data/site';
export function SalonSection() {
  return <section id="salon" aria-labelledby="salon-title" className="relative w-full bg-forest-900" data-id="element-61" data-mp="3rujejcskpy3s">
      <div className="grid lg:grid-cols-12" data-id="element-62" data-mp="3mux1p4gnqjvi">
        <div className="relative lg:col-span-8" data-id="element-63" data-mp="3mvon5mgjj182">
          <img src={images.salon} alt="Le salon du bistrot : murs vert sombre, abat-jours fleuris à franges, canapé et fauteuils en fer forgé" className="h-[60vh] w-full object-cover lg:h-full lg:min-h-[80vh]" loading="lazy" data-id="element-64" data-mp="3hwc133xhty6j" />
        </div>
        <div className="flex flex-col justify-center px-6 py-16 lg:col-span-4 lg:px-12 lg:py-24" data-id="element-65" data-mp="9g0g556cj26h">
          <h2 id="salon-title" className="font-serif text-5xl font-light leading-[1.05] text-cream-50" data-id="element-66" data-mp="4hfqfzoq00wa">
            Un salon pour prolonger la soirée
          </h2>
          <p className="mt-6 leading-relaxed text-cream-100/75" data-id="element-67" data-mp="2u7suqty07vh3">
            Abat-jours à franges, fauteuils chinés, cheminée en marbre : à l’étage, un salon où l’on s’installe pour un
            verre, un café ou un dernier dessert.
          </p>
          <p className="mt-4 leading-relaxed text-cream-100/75" data-id="element-68" data-mp="3ntat4up3jmq6">
            Il se privatise aussi pour vos anniversaires, repas de famille ou soirées entre amis.
          </p>
          <a href="#infos" className="mt-10 inline-flex w-fit whitespace-nowrap border-b border-ember-400 pb-1 text-sm font-medium text-ember-400 transition-colors duration-150 hover:text-cream-50 hover:border-cream-50" data-id="element-69" data-mp="3dul8iu5tfo68">
            Demander une privatisation
          </a>
        </div>
      </div>
    </section>;
}